// istanbul ignore file
import { useCallback, useRef } from 'react';
import { throttle } from 'lodash';

export const CLD_ANALYTICS_ATTRIBUTE = 'data-cld-analytics';

export const CLD_ANALYTICS_ACTION = 'data-cld-action';

export const analytics = (category: string, label: string, action = 'click') => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'event to GA',
      eventCategory: category,
      eventLabel: label,
      eventAction: action,
    });
  }
};

export const useAnalytics = (category: string) => {
  return useCallback(
    (label: string, action?: string) => {
      analytics(category, label, action);
    },
    [category]
  );
};

export const useAnalyticsOnce = (category: string) => {
  const isOnce = useRef(true);

  return useCallback(
    (label: string, action?: string) => {
      if (isOnce.current) {
        analytics(category, label, action);
        isOnce.current = false;
      }
    },
    [category]
  );
};

export const useThrottleAnalytics = (category: string, wait: number) => {
  const setAnalytics = throttle(useAnalytics(category), wait);

  return useCallback(
    (label: string, action?: string) => {
      setAnalytics(label, action);
    },
    [setAnalytics]
  );
};

export const getAnalyticsProp = (analyticsMessage?: string, analyticsAction?: string) => ({
  [CLD_ANALYTICS_ATTRIBUTE]: analyticsMessage,
  ...(analyticsMessage && analyticsAction && { [CLD_ANALYTICS_ACTION]: analyticsAction }),
});
